import { useHistory } from 'react-router-dom';
import removeImg from '../assets/images/Remove.svg';
import { Button } from '../components/Button';

import '../styles/not-found.scss';

export function NotFound() {
  const history = useHistory();

  function handleBackToHome() {
    history.push('/');
  }

  return (
    <div id="page-not-found">
      <main>
        <img src={removeImg} alt="Not found" />
        <h2>404</h2>
        <h3>Página não encontrada</h3>
        <Button type="button" onClick={handleBackToHome}>Voltar</Button>
      </main>
    </div>
  );
}